var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuaternary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#6A6B6C;stroke-width:12.3364;stroke-miterlimit:10;}\n\t.st1{fill:#6A6B6C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.7,149c-32.2,31.6-83.6,30.9-115-1.6C0.4,114.8,1.1,62.8,33.3,31.1s83.6-31,115,1.6S178.9,117.3,146.7,149 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.2,65.1c-0.7,1.6-0.9,2.6,1.4,3.3c3.7,1.2,5.6,4.2,5.6,8.1c0.1,4,0.1,7.9,0,11.9c-0.1,1.7,0.4,2.7,1.9,3.7 c6.7,4.2,11.1,10.2,13,18c2,8,1.4,16.2,0.8,24.2c-0.6,7-6.6,11.8-13.4,11.9c-10.9,0.1-21.8,0.1-32.8,0c-6.8-0.1-12.4-5.1-13.4-12 c-0.7-5.2-0.3-10.4-0.3-15.6c0.1-11.5,4.8-20.5,14.4-26.7c1.1-0.7,1.6-1.4,1.5-2.7c-0.1-3.8-0.1-7.8,0-11.6c0-4.9,1.9-7.9,6.4-9.5 c1.1-0.4,1.4-0.9,1.4-2c-0.1-3.2-0.1-6.3,0-9.6c0.1-1.5-0.4-2.1-1.9-2c-2.5,0.1-5-0.1-7.5,0.1c-2.1,0.1-2.1-0.7-1.7-2.4 c1.3-5.2,5.5-8.6,10.8-8.6c7.1-0.1,14.1,0,21.2,0c5.1,0,4.9,0,5.1,5.1c0.1,3.7,0.3,7.1-4.6,7.6c-1.8,0.2-1.9,1.4-1.1,2.9 c1.2,2.5,3,4.3,5.5,5.1c1.1,0.4,2.1,0.6,1.8,2c-0.4,1.5-1.7,0.9-2.6,0.7c-4-0.4-7.2-2.4-9.7-5.6C87.2,62.6,86.7,63.9,86.2,65.1  M95,140c5-0.1,8-3.1,8-8.1c-0.1-6.3,0.7-12.8-0.5-19c-1.4-7.5-5.7-13-12.4-16.4c-2.2-1.1-3.1-2.6-3-5c0.1-4.5,0.1-9.1,0-13.6 c-0.1-3.1-0.9-3.9-4-4c-2.8-0.1-5.5,0-8.3,0c-2.5,0-3.6,1.1-3.6,3.7c0.1,4.6-0.1,9.3,0.1,13.9c0.1,2.3-0.7,3.7-2.8,4.8 c-8.9,4.7-13.1,12.3-13.2,22.3c-0.1,4.1,0,8.1,0,12.2c0,6.3,2.8,9.3,9,9.3c5,0,9.9,0,14.9,0C84.4,140,89.6,140,95,140"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.2,49.2c0,5.8,0,5.8,6,5.8c1.7,0,2.6-0.4,2.3-2.2c-0.1-1.1,0-2.1,0-3.2c0-6.2,0-6.1-5.8-6.1 c-2.1-0.1-2.7,0.6-2.4,2.6C101.3,47.1,101.2,48.2,101.2,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.1,51.6c1.4,0.1,2.6-0.4,2.6-2.1c-0.1-2.2-1.9-1.9-3.5-1.9c-1.4,0-2.6,0.3-2.6,1.9 C120.7,51.7,122.4,51.5,124.1,51.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.7,41.7c1.4-0.6,2.9-1.2,3.3-3c0.3-1.2-0.6-2.2-1.7-2.1c-1.6,0.1-3.1,1.1-3.4,2.9 C117.6,40.7,118.3,41.5,119.7,41.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.8,60c0.4,1.6,1.7,2.6,3.3,2.9c1.1,0.1,2.1-0.6,1.9-2c-0.4-1.9-1.7-2.7-3.4-2.9 C118.4,57.9,117.9,58.6,117.8,60"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.6,47.5c-1.6,0-2.6,0.6-2.6,1.9c0,1.6,1.1,2.1,2.6,2.1c1.4,0,2.4-0.6,2.4-2 C134.7,48.2,133.7,47.4,132.6,47.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.7,47.6c-1.3,0-2.2,0.6-2.1,2c0.1,1.6,1.1,2.1,2.5,2c1.3-0.1,2.2-0.6,2.2-2 C117.3,47.9,116.1,47.5,114.7,47.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.6,62.6c-1.4,0.1-2.1,0.9-1.9,2.1c0.2,1.4,1.4,2.4,2.7,2.5c1.1,0.1,1.9-0.8,1.9-2.1 C128,63.4,126.9,62.9,125.6,62.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.5,43.8c0.1,1.4,0.6,2.1,1.9,2c1.4-0.1,2.6-1.1,2.6-2.5c0.1-1.2-0.9-2.1-1.9-1.9 C113.9,41.5,112.7,42.3,112.5,43.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.5,34.8c0.1,1.3,0.8,2.2,1.9,2.1c1.4-0.1,2.6-0.9,2.7-2.5c0.1-1.2-0.6-2.1-1.8-2.1 C125,32.6,124.1,33.6,123.5,34.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.5,55.9c0.2,1.4,1.3,2.2,2.7,2.3c1.1,0.1,1.9-0.6,1.9-1.7c-0.1-1.7-1.3-2.6-2.8-2.6 C113.2,53.8,112.6,54.6,112.5,55.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.4,131.9c4.7,0,9.4-0.1,14,0.1c1.6,0.1,2.4-0.2,2.4-2.2c-0.1-4.5-0.1-9.1,0-13.6c0.1-1.9-0.6-2.2-2.4-2.2 c-9.5,0.1-19.1,0.1-28.6,0c-1.6,0-2.1,0.4-2.1,2.1c0.1,4.6,0.1,9.3,0,13.9c-0.1,1.7,0.5,2.1,2.1,2.1 C69.6,131.8,74.5,131.9,79.4,131.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuaternary);
export default __webpack_public_path__ + "static/media/Quaternary.a4cd188afc5b76fd8396c7e3899c272d.svg";
export { ForwardRef as ReactComponent };